import clsx from 'clsx';
import { format } from 'date-fns';
import { useRouter } from 'next/router';
import React from 'react';
import { useTranslation } from 'react-i18next';

import { useCancelPlan, useGetSubscribePlan } from '@/modules/payment/apiHooks';
import { Typography } from '@/shared/components/atoms';
import DotedMenu from '@/shared/components/molecules/DotedMenu';
import { useAuth } from '@/shared/hooks/context/auth';

import Close from '~/images/shared/CloseSquare.svg';
import DollarSign from '~/images/shared/DollarSquare.svg';
import DotsMenu from '~/images/shared/HorizontalHollowDots.svg';

const SubcribedPlanCard = () => {
  const { reload } = useRouter();
  const { user } = useAuth();
  const { t } = useTranslation('payment');
  const { data } = useGetSubscribePlan();
  const { mutate: cancelPlanMutation } = useCancelPlan();
  // TODO: IMP - this should update depending on plan type (month - year)

  return (
    // gap-11
    <div className='flex h-full w-full flex-col gap-80 rounded-xl border-xs border-neutralVariant-90 bg-background-neutral-99 p-24 '>
      {data ? (
        <>
          <div className='flex flex-col gap-2'>
            <div className='flex justify-between gap-2'>
              <div className='flex h-fit gap-2'>
                <Typography
                  variant='body1'
                  weight='semiBold'
                  className='text-text-default'
                >
                  {data.planName}
                </Typography>
                {!user?.subscription?.isSetToCancel && (
                  <DotedMenu
                    list={[
                      // {
                      //   title: t('change-plan'),
                      //   id: '0',
                      //   action: () => push(routes.subscription),
                      // },
                      ...(user?.subscription?.isSetToCancel
                        ? []
                        : [
                            {
                              title: t('cancel-subscription'),
                              id: '1',
                              action: () =>
                                cancelPlanMutation(undefined, {
                                  onSuccess: reload,
                                }),
                            },
                          ]),
                    ]}
                    getTitle={(item) => (
                      <div
                        className={clsx(
                          'text-1 flex items-center gap-1',
                          item.id === '1'
                            ? 'text-error-400'
                            : 'text-primary-default'
                        )}
                      >
                        {item.id === '1' && <Close width='14' height='14' />}
                        {item.id === '0' && (
                          <DollarSign width='14' height='14' />
                        )}
                        <span className='whitespace-nowrap'>{item.title}</span>
                      </div>
                    )}
                    getId={(item) => item?.id}
                    getAction={(item) => item.action}
                    // eslint-disable-next-line no-console
                    onOpen={() => console.log('opened')}
                    DotsMenuIcon={<DotsMenu className='text-24' />}
                  />
                )}
              </div>
              <div className='flex flex-col'>
                <Typography
                  variant='h2'
                  weight='semiBold'
                  className='text-text-default'
                >
                  {t(`${data.currency}-sign`)}
                  {data.price}
                </Typography>
                <Typography variant='body2' className='text-surface-10'>
                  {data.interval === 'year'
                    ? `${t('per-field')}, ${t('per-year')}`
                    : `${t('per-field')}, ${t('per-month')}`}
                </Typography>
              </div>
            </div>
            {/* <div className='w-fit rounded-lg bg-outline-default py-1 px-2 text-primary-400'>
              {data.numberOfFields ?? 0} {t('fields')}
            </div> */}
          </div>
          <div className='flex items-center gap-1 text-base'>
            <span className='text-surface-10'>
              {t(data.interval === 'year' ? 'annual' : 'monthly')}{' '}
              {t('renewal-date')}:
            </span>
            <span className='text-text-default'>
              {format(new Date(data?.renewalDate), 'MMM dd, yyyy')}
            </span>
          </div>
        </>
      ) : (
        <div className='flex h-full w-full items-center justify-center'>
          {t('no-plan')}
        </div>
      )}
    </div>
  );
};

export { SubcribedPlanCard };
